var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: "",
        width: "35%",
        title: _vm.$t("admin.selectionTips"),
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "div",
        { staticClass: "flex mt-15 justify-center" },
        _vm._l(_vm.fapiaoSelectionOptions, function (item) {
          return _c(
            "div",
            {
              key: item.type,
              staticClass: "selection-card border-normal",
              class: [item.checked ? "selected" : ""],
              on: {
                click: function ($event) {
                  return _vm.handleCheckedChange(item)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "selection-btn" },
                [
                  _c("el-checkbox", {
                    on: {
                      change: function ($event) {
                        return _vm.handleCheckedChange(item)
                      },
                    },
                    model: {
                      value: item.checked,
                      callback: function ($$v) {
                        _vm.$set(item, "checked", $$v)
                      },
                      expression: "item.checked",
                    },
                  }),
                ],
                1
              ),
              _c("svg-icon", {
                attrs: { "icon-name": item.iconName, size: 64 },
              }),
              _c("p", { staticClass: "label" }, [_vm._v(_vm._s(item.name))]),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary" },
              on: { click: _vm.confirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }